import Vue from 'vue'
import Vuex from 'vuex'

import createPersistedState from 'vuex-persistedstate'

import state from './state'
import mutations from './mutations'
import * as actions from './actions'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  plugins: [createPersistedState({
    paths: [
      'userLocation',
      'isLoggedIn',
      'fingerprint',
      'game',
      'questionRadius',
      'team',
      'apiKey',
      'mapZoom',
      'mapCenter',
      'config',
      'tenant',
    ]
  })]
})



// WEBPACK FOOTER //
// ./src/store/store.js